import { FullWidthImage, FullWidthImageAspectProps } from "~/ui-library";

export type ArticleFeaturedImageProps = Omit<
  FullWidthImageAspectProps,
  "aspectRatio"
>;

export const ArticleFeaturedImage = (props: ArticleFeaturedImageProps) => (
  <FullWidthImage {...props} aspectRatio="16/9" priority={true} />
);
